import editableFieldView from './editableFieldComponent.html';
import './editableFieldComponent.css';

export function editableFieldComponent() {
	return {
		bindings: {
			resource: '@',
			field: '@',
			record: '=',
			mode: '=?',
			width: '@',
		},
		controllerAs: 'vm',
		controller: editableFieldComponentCtrl,
		template: editableFieldView,
	};
}

export class editableFieldComponentCtrl {
	constructor(Api) {
		'ngInject';
		this.Api = Api;
		this.mode = this.mode || 'view';
	}

	save() {
		const data = {
			[this.field]: this.record[this.field],
		};
		this.Api.patch(`/${this.resource}/${this.record.id}`, data);
	}
}
